import React, { useEffect, useState } from 'react';
import icon1 from '../../../../../assets/restaurant/images/color-icon1.png';
import icon2 from '../../../../../assets/restaurant/images/color-icon2.png';
import icon3 from '../../../../../assets/restaurant/images/color-icon3.png';
import { LOADER_TIMEOUT_TIME } from '../../../../../utils/Constants';
import { showPrice, TrimText } from '../../../../../utils/commonfunction';
import { useTranslation } from 'react-i18next';

export default function StaffPageDashboard() {

  const { t } = useTranslation();
  const [loader, setLoader] = useState(true);
  const [List, setList] = useState([]);


 
  return (
   <>
   DashBoard
   </>
  )
}
